




import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import SimpleText from "front-component/components/SimpleText.vue";

// CreatorFullName interface
interface Request {
    createdBy: {
        displayName: string;
    };
}

@Component({ components: { SimpleText } })
export default class Requester extends Vue {
    @Prop() public request!: Request;

    public static getNeededFields(): string[] {
        return [
            "request.createdBy.displayName",
            "request.children.createdBy.displayName",
        ];
    }
}
